// src/pages/SourceofInformation.jsx
import contactBg from '../assets/images/contact-bg.png';
import { Container, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { informationSourceData } from '../utils/source-of-information'; // ← local data

const SourceofInformation = () => {
  return (
    <>
      <section
        className="contact-banner"
        style={{
          backgroundImage: `url(${contactBg})`,
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          marginBottom: '50px',
          position: 'relative',
          overflow: 'hidden',
          paddingTop: '180px',
          minHeight: '450px',
        }}
      >
        <div className="floating-dots">
          {[...Array(10)].map((_, i) => (
            <div className="dot" key={i}></div>
          ))}
        </div>

        <Container>
          <Row className="align-items-center">
            <div className="col-lg-12">
              <div className="section_title top_content text-center ">
                <span className="title_badge mb-1" style={{ background: '#674EDD' }}>
                  Source of Information
                </span>
                <h2 className="freeLive-Test">Source of Information</h2>
                <p className="mb-0">
                  At Vidyakasam, we ensure all our study materials and test series are meticulously crafted using
                  official government sources, guaranteeing the most accurate preparation resources.
                </p>
                <ul className="banner-nav">
                  <li><Link to="/">Home</Link></li>
                  <li><span>»</span></li>
                  <li><Link to="/source-of-information">Source of Information</Link></li>
                </ul>
              </div>
            </div>
          </Row>
        </Container>
      </section>

      <section className="sourceInformation my-4">
        <Container>
          <Row>
            <div className="col-lg-12 text-center">
              <h3 className="mb-4">Data Sources</h3>
            </div>

            {informationSourceData.map((it, idx) => (
              <div className="col-lg-3 col-md-4 col-sm-6 mb-4" key={`${it.key}-${idx}`}>
                <div className="card p-3 h-100 d-flex justify-content-between">
                  <p className="mb-2">{it.key}</p>
                  <a
                    href={it.value}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="stretched-link"
                  >
                    Visit Official Website
                  </a>
                </div>
              </div>
            ))}
          </Row>
        </Container>
      </section>
    </>
  );
};

export default SourceofInformation;